// Hide "view more" when loaded products
jQuery(document.body).on('post-load', function($) {
	jQuery('.view-next').hide();
	jQuery('.infinite-wrap .view-next').show();
});

jQuery(document).ready(function($) {

	/* Validation */
	$('#form-contact').validate();

	$('#register-form').validate({
		errorPlacement: function(error, element) { }
	});

	$('#order-form').validate({
		errorPlacement: function(error, element) { }
	});

	/* Home Slider */
	$('.home-slider').flexslider({
		animation: 'fade',
		directionNav: false,
	});

	/* Galleries */
	$('.product-gallery').flexslider({
	  animation: 'slide',
	  controlNav: false,
	  animationLoop: false,
	  slideshow: false,
	  keyboard: true,
	  prevText: '&lsaquo;',
	  nextText: '&rsaquo;',
	  sync: ".product-gallery-thumbs"
	});

	$('.product-gallery-thumbs').flexslider({
	  animation: "slide",
	  controlNav: false,
	  animationLoop: false,
	  slideshow: false,
	  directionNav: false,
	  itemWidth: 73,
	  itemMargin: 4,
	  minItems: 4,
	  maxItems: 4,
	  move: 4,
	  asNavFor: '.product-gallery',
	  prevText: '&lsaquo;',
	  nextText: '&rsaquo;'
	});

	lightbox.option({
		"fitImagesInViewport": true,
		"maxWidth": 1000,
		"maxHeight": 1000,
	});

	/* Cookie Info */
	if ($.cookie('cookiesAcknowledged') != 'true'){
		$('#cookie-info').fadeTo(500, 1);
	}

	$('#cookie-info #cookie-close').click(function() {
		$('#cookie-info').fadeTo(500, 0);
	  	$.cookie('cookiesAcknowledged', true, { expires: 168, path: '/'});
	});

	/* Navigation */
	$('.navigation-container').responsiveNavigation();

	$(".content").fitVids();

});
